export const PUBLIC_LANGUAGES = ["uz", "en", "ru"];
export const PUBLIC_UI = {
  uz: {
    home: "Bosh sahifa",
    guides: "Qo‘llanmalar",
    login: "Kirish",
    signup: "Ro‘yxatdan o‘tish",
    start: "Rejamni yaratish",
    try: "Ish maydonini ochish",
    steps: "DayX’da qanday boshlash mumkin?",
    example: "Amaliy misol",
    exampleNote:
      "Bu tushuntirish uchun namuna. Ish maydoningiz o‘z rejalaringiz bilan boshlanadi.",
    faq: "Ko‘p beriladigan savollar",
    related: "Keyingi qadamingiz",
    read: "Qo‘llanmani o‘qish",
    rights: "Barcha huquqlar himoyalangan.",
    language: "Til",
    overview: "Reja tuzishdan natijani ko‘rishgacha",
    overviewText:
      "DayX vositalaridan qanday foydalanishni aniq misollar va qisqa qo‘llanmalar bilan o‘rganing.",
    cta: "Bugun bitta aniq qadamdan boshlang.",
    ctaText:
      "O‘z rejangizni yarating, unga vaqt ajrating va bajargan ishingizni belgilang.",
  },
  en: {
    home: "Home",
    guides: "Guides",
    login: "Log in",
    signup: "Sign up",
    start: "Create my plan",
    try: "Open workspace",
    steps: "How to get started in DayX",
    example: "A practical example",
    exampleNote:
      "An illustrative example. Your workspace starts with your own plans.",
    faq: "Frequently asked questions",
    related: "Your next step",
    read: "Read the guide",
    rights: "All rights reserved.",
    language: "Language",
    overview: "From daily plans to visible progress",
    overviewText:
      "Learn how to use DayX with practical examples and short guides to planning, tracking and focus.",
    cta: "Start with one clear step today.",
    ctaText:
      "Create your own plan, give it time and mark the work you complete.",
  },
  ru: {
    home: "Главная",
    guides: "Руководства",
    login: "Войти",
    signup: "Регистрация",
    start: "Создать мой план",
    try: "Открыть пространство",
    steps: "Как начать пользоваться DayX",
    example: "Практический пример",
    exampleNote:
      "Это пример для пояснения. В вашем пространстве будут ваши собственные планы.",
    faq: "Частые вопросы",
    related: "Ваш следующий шаг",
    read: "Читать руководство",
    rights: "Все права защищены.",
    language: "Язык",
    overview: "От планов на день к заметному прогрессу",
    overviewText:
      "Узнайте, как пользоваться DayX: практические примеры и короткие руководства по планированию, отслеживанию и фокусу.",
    cta: "Начните сегодня с одного понятного шага.",
    ctaText:
      "Создайте свой план, выделите для него время и отмечайте выполненную работу.",
  },
};

export const PUBLIC_TOPICS = [
  {
    id: "daily-planner",
    labels: { uz: "Kunlik reja", en: "Daily planner", ru: "Планы на день" },
    term: "Daily planner",
    icon: "today",
    route: "manage",
    copy: {
      uz: {
        title: "Kunlik va haftalik reja — Daily planner | DayX",
        heading: "Kunlik rejangizga aniq yo‘nalish bering.",
        description:
          "DayX kunlik reja vositasi bilan ish kunlari va dam olish kunlari uchun reja tuzing. Haftalik jadval va 30 kunlik reja jadvalidan foydalanishni o‘rganing.",
        summary:
          "Har kuni bir xil reja qiling, kunlarni guruhlang yoki har haftani alohida rejalang.",
        intro:
          "Kunlik reja — bugun muhim bo‘lgan ishlarga vaqt ajratish usuli. DayX daily planner o‘qish, ish va shaxsiy maqsadlar uchun bir joyda reja tuzishga yordam beradi.",
        sections: [
          [
            "Kunlik reja qanday tuziladi?",
            "Avval bajarilishi mumkin bo‘lgan uchta ishni tanlang. Har birini aniq yozing: masalan, «ingliz tilini o‘rganish» o‘rniga «20 daqiqa yangi so‘zlarni takrorlash». Kerak bo‘lsa, vaqt va izoh qo‘shing. Rejangiz kunning haqiqiy imkoniyatlariga mos bo‘lsin.",
          ],
          [
            "Haftalik reja va 30 kunlik jadval",
            "Har kuni bir xil reja, istalgan kun guruhlari yoki har bir sana uchun alohida haftalik reja tanlang. Masalan, dushanba, chorshanba va juma bir guruh, qolgan kunlar boshqa guruh bo‘lishi mumkin. Haftalik ko‘rinish yetti kunni ko‘rsatadi. Takrorlanuvchi rejalar jadvali guruhning 30 ta rejalashtirilgan kunini qamrab oladi; bu har doim bitta kalendar oy degani emas.",
          ],
          [
            "Reja o‘zgarsa, uni qayta tartiblang",
            "Rejalarni boshqarishda nom va vaqtni to‘g‘ridan-to‘g‘ri tahrirlang, keyin Saqlash tugmasini bosing. Muhim ishni ushlab ro‘yxat boshiga ko‘chiring; klaviaturada tartiblash tugmasi va strelkalardan foydalaning. Takrorlanuvchi rejalar tanlangan kunlarda ko‘rinadi, har bir sana uchun bajarilish alohida saqlanadi.",
          ],
        ],
        steps: [
          "Rejalash uslubini tanlang: har kuni bir xil, moslashtirilgan kun guruhlari yoki har haftani alohida.",
          "Birinchi rejangizga nom, kerakli vaqt va qisqa izoh kiriting.",
          "Bugungi rejada ishlarni ko‘ring; umumiy ko‘rinish uchun haftalik sahifa yoki reja jadvalini oching.",
        ],
        example: [
          "08:00 · 20 daqiqa kitob o‘qish",
          "09:00 · Yangi so‘zlarni takrorlash",
          "10:00 · Asosiy loyiha ustida ishlash",
        ],
        faq: [
          [
            "Daily planner va vazifalar ro‘yxati nimasi bilan farq qiladi?",
            "Vazifalar ro‘yxati bajariladigan ishlarni sanaydi. Kunlik reja ularni tartib va vaqt bilan bog‘laydi. DayX’da rejangizga vaqt yozib, bajarilishini kunlar bo‘yicha kuzatishingiz mumkin.",
          ],
          [
            "Har bir kun uchun alohida reja tuziladimi?",
            "Ha. Haftalik rejada har bir sana uchun alohida vazifalar yozishingiz mumkin. Takrorlanuvchi rejalar uchun istalgan kunlarni guruhlang yoki yetti kunning barchasiga bitta reja tanlang. Har bir sananing bajarilish belgisi alohida saqlanadi.",
          ],
        ],
      },
      en: {
        title: "Daily planner and weekly plans | DayX",
        heading: "A daily plan with a clear next step.",
        description:
          "Build weekday and weekend plans with the DayX daily planner. Learn to organize your weekly schedule and use a 30-day plan table with practical examples.",
        summary:
          "Repeat one daily routine, group any days together or plan each week separately.",
        intro:
          "A daily planner gives important work a place in your day. DayX brings daily plans, weekly planning and a plan table together for studying, work and personal goals.",
        sections: [
          [
            "How to make a useful daily plan",
            "Choose three tasks that fit the time you actually have. Make each one specific: instead of «learn English», write «review vocabulary for 20 minutes». Add a schedule and a note when they help. A manageable daily plan is easier to act on than a long list with no priorities.",
          ],
          [
            "Weekly plans and the 30-day table",
            "Choose one routine for every day, custom day groups or separate plans for each date. For example, Monday, Wednesday and Friday can share one routine while the remaining days share another. Weekly shows seven days together. The repeating plan table covers 30 scheduled days for the selected group; this is not necessarily one calendar month.",
          ],
          [
            "Adjust your plans as your routine changes",
            "Edit names and times directly in Manage Plans, then save your changes. Drag important tasks higher in the list, or focus the reorder handle and use the arrow keys. Repeating plans appear on the days you choose, while completion marks remain separate for each date.",
          ],
        ],
        steps: [
          "Choose one daily routine, custom day groups or separate weekly plans in Planning setup.",
          "Add your first plan with a clear name, an optional schedule and a short note.",
          "Open Today to work through it. Use Weekly or Plan Table to review the days ahead.",
        ],
        example: [
          "08:00 · Read for 20 minutes",
          "09:00 · Review new vocabulary",
          "10:00 · Work on the main project",
        ],
        faq: [
          [
            "What is the difference between a daily planner and a task list?",
            "A task list names the work. A daily planner gives that work an order and a place in your schedule. DayX lets you add a schedule and track each plan by date.",
          ],
          [
            "Can I create a different routine for each weekday?",
            "Yes. Choose weekly planning to write separate tasks for each date. For repeating routines, group any weekdays together or use one plan for all seven days. Completion marks are always stored separately for each date.",
          ],
        ],
      },
      ru: {
        title: "Планировщик дня и планы на неделю | DayX",
        heading: "План на день с понятным следующим шагом.",
        description:
          "Составляйте планы на будни и выходные в DayX. Узнайте, как пользоваться планировщиком дня, недельным расписанием и таблицей на 30 запланированных дней.",
        summary:
          "Повторяйте общий распорядок, объединяйте дни в группы или планируйте каждую неделю отдельно.",
        intro:
          "Планировщик дня помогает выделить время для важных дел. DayX объединяет ежедневные планы, недельный обзор и таблицу планов для учёбы, работы и личных целей.",
        sections: [
          [
            "Как составить выполнимый план на день",
            "Выберите три дела, на которые действительно хватит времени. Сформулируйте каждое конкретно: вместо «учить английский» напишите «повторять слова 20 минут». При необходимости добавьте время и заметку. Короткий план с понятными приоритетами проще выполнить, чем длинный список без порядка.",
          ],
          [
            "Недельный план и таблица на 30 дней",
            "Выберите общий распорядок на каждый день, собственные группы дней или отдельные планы на каждую дату. Например, понедельник, среда и пятница могут составить одну группу, а остальные дни — другую. Недельный обзор показывает семь дней. Таблица повторяющихся планов охватывает 30 запланированных дней группы; это не обязательно один календарный месяц.",
          ],
          [
            "Меняйте планы вместе с распорядком",
            "В разделе управления планами можно изменить название, время и заметку, а важные дела переместить выше. План повторяется в соответствующих буднях или выходных, поэтому новый список для каждой даты не нужен. При этом выполнение отмечается отдельно для каждого дня.",
          ],
        ],
        steps: [
          "Выберите общий распорядок, свои группы дней или отдельные недельные планы в настройке планирования.",
          "Добавьте первый план: конкретное название, время по желанию и короткую заметку.",
          "Откройте сегодняшний день. Для общего обзора используйте неделю или таблицу планов.",
        ],
        example: [
          "08:00 · Читать 20 минут",
          "09:00 · Повторить новые слова",
          "10:00 · Работать над главным проектом",
        ],
        faq: [
          [
            "Чем планировщик дня отличается от списка задач?",
            "Список задач перечисляет дела. Планировщик связывает их с порядком и временем. В DayX можно указать расписание и отслеживать выполнение по датам.",
          ],
          [
            "Можно ли создать отдельный распорядок для каждого дня недели?",
            "Да. В недельном режиме можно записать отдельные задачи для каждой даты. Для повторяющегося распорядка объедините любые дни в группы или выберите один план на все семь дней. Выполнение сохраняется отдельно для каждой даты.",
          ],
        ],
      },
    },
  },
  {
    id: "plan-tracker",
    labels: { uz: "Natijalar kuzatuvi", en: "Plan tracker", ru: "Прогресс" },
    term: "Plan tracker",
    icon: "all",
    route: "weekly",
    copy: {
      uz: {
        title: "Reja va natijalar kuzatuvi — Plan tracker | DayX",
        heading: "Bajarilgan ishlarni ko‘ring. Keyingi qadamni tanlang.",
        description:
          "DayX plan tracker bilan kunlik rejalar bajarilishini belgilang, haftalik natijalarni va 30 kunlik jadvalni ko‘ring. Natijalar kuzatuvi bo‘yicha amaliy qo‘llanma.",
        summary:
          "Rejalaringiz bajarilishini sana bo‘yicha belgilang va haftalik natijalarni ko‘ring.",
        intro:
          "Plan tracker rejalangan ish bilan amalda bajarilgan ishni solishtirishga yordam beradi. DayX’da har bir bajarilish belgisi ma’lum bir sana va rejaga tegishli; natijani taxmin qilish o‘rniga yozilgan belgilarga qaraysiz.",
        sections: [
          [
            "Natijalarni kuzatish nimadan boshlanadi?",
            "Avval o‘z rejalaringizni yarating. Ish tugagach, bugungi ro‘yxatda uning bajarilganini belgilang. Belgilashda adashsangiz, uni olib tashlashingiz mumkin. Takrorlanuvchi rejaning bir kun bajarilishi boshqa kunlarni avtomatik bajarilgan qilmaydi.",
          ],
          [
            "Haftalik natijani qanday o‘qish kerak?",
            "Haftalik sahifa har bir kun uchun bajarilgan va jami rejalar sonini, shuningdek bajarilish foizini ko‘rsatadi. Foiz reja bandlarining bajarilishiga asoslanadi; u ishlangan soat yoki ish sifatining o‘lchovi emas. Natijalarni solishtirganda har kuni rejalashtirgan yuklamangizni ham hisobga oling.",
          ],
          [
            "30 kunlik kuzatuv va kunlar tarixi",
            "Reja jadvali tanlangan guruhdagi 30 ta rejalashtirilgan kunni ko‘rsatadi. Barcha kunlar sahifasida sanalar bo‘yicha tarixni ko‘rishingiz mumkin. Kelajakdagi kunlar oldindan ko‘rinadi, ammo ularni oldindan bajarilgan deb belgilash mumkin emas. Shu ko‘rinishlardan foydalanib, rejangizni yengillashtirish yoki vaqtini o‘zgartirishni tanlang.",
          ],
        ],
        steps: [
          "Bugungi rejada faqat tugatgan ishlaringizni belgilang.",
          "Haftalik sahifada bajarilgan ishlar soni va kunlar orasidagi farqni ko‘ring.",
          "Reja jadvali yoki kunlar tarixini oching; takrorlanayotgan qiyinchilikka qarab rejangizni tahrirlang.",
        ],
        example: [
          "3 ta reja · 2 tasi bajarildi",
          "Bajarilish: 2 ÷ 3 ≈ 67%",
          "Keyingi qadam: qolgan ishga vaqt ajratish",
        ],
        faq: [
          [
            "Bu odatlar trekeri sifatida ishlaydimi?",
            "Takrorlanuvchi rejalarga kitob o‘qish yoki til o‘rganish kabi odatlarni qo‘shib, kunlik bajarilishini kuzatishingiz mumkin. DayX har bir rejaning bajarilish belgisini sanalar bo‘yicha saqlaydi.",
          ],
          [
            "Akkauntim bo‘lsa, boshqa qurilmada natijalarim ko‘rinadimi?",
            "Ha. Bir xil akkauntga kirganingizda serverda saqlangan reja va natijalaringiz ochiladi. Mehmon rejimida ishlagan bo‘lsangiz, ro‘yxatdan o‘tishda mehmon rejalaringiz yangi akkauntga o‘tadi.",
          ],
        ],
      },
      en: {
        title: "Daily plan tracker and progress tracking | DayX",
        heading: "See what you finished. Choose what comes next.",
        description:
          "Track completed plans by date with the DayX plan tracker. Review weekly progress, a 30-day plan table and your daily history with this practical guide.",
        summary:
          "Track daily completion and review your progress across the week.",
        intro:
          "A plan tracker connects what you intended to do with what you actually finished. In DayX, each completion belongs to a specific plan and date, giving your progress tracking a clear record to work from.",
        sections: [
          [
            "Start with an honest completion record",
            "Create your own plans first, then mark a task in Today after finishing it. You can clear a mark if you made a mistake. Completing a repeating plan on one date does not mark it complete on another date. The record grows from your actions rather than from sample tasks or an assumed routine.",
          ],
          [
            "Read your weekly progress in context",
            "Weekly shows completed and total plans for each day, together with completion percentages. These percentages measure completed plan items, not hours worked or the quality of your work. Compare the amount you scheduled as well as the percentage: a busy day with many small tasks differs from a day with one substantial task.",
          ],
          [
            "Review the table and daily history",
            "Plan Table displays 30 scheduled days for the selected weekday or weekend group. All Days provides a dated timeline around the selected date. Future days can be viewed but cannot be marked complete in advance. Use these views to notice a recurring obstacle, then adjust the schedule or reduce the size of the plan.",
          ],
        ],
        steps: [
          "Mark only the work you have finished in Today.",
          "Open Weekly to compare completed plans and the workload across days.",
          "Review Plan Table or All Days, then edit the routine when a task repeatedly needs a different time or size.",
        ],
        example: [
          "3 planned tasks · 2 completed",
          "Completion: 2 ÷ 3 ≈ 67%",
          "Next step: make time for the remaining task",
        ],
        faq: [
          [
            "Can I use DayX as a habit tracker?",
            "You can add recurring activities such as reading or language practice to your plans and track their daily completion. DayX records each plan’s completion separately by date.",
          ],
          [
            "Can I see my progress on another device?",
            "Yes. Sign in to the same account to open your server-saved plans and completion history. If you started as a guest, registration moves those guest plans into your new account.",
          ],
        ],
      },
      ru: {
        title: "Трекер планов и отслеживание прогресса | DayX",
        heading: "Видьте сделанное. Выбирайте следующий шаг.",
        description:
          "Отмечайте выполнение планов по датам в DayX. Практическое руководство по трекеру задач, недельному прогрессу, таблице на 30 дней и истории выполнения.",
        summary:
          "Отмечайте выполнение по датам и просматривайте результаты за неделю.",
        intro:
          "Трекер планов помогает сравнить запланированное с выполненным. В DayX каждая отметка относится к конкретному плану и дате, поэтому отслеживание прогресса опирается на понятную историю действий.",
        sections: [
          [
            "Начните с точных отметок выполнения",
            "Сначала создайте собственные планы, а затем отмечайте дело в сегодняшнем списке после его завершения. Ошибочную отметку можно снять. Выполнение повторяющегося плана в одну дату не отмечает его выполненным в другие дни. История строится на ваших действиях, а не на примерных задачах.",
          ],
          [
            "Оценивайте недельный прогресс в контексте",
            "Недельный обзор показывает количество выполненных и запланированных дел по дням, а также процент выполнения. Процент отражает выполненные пункты, а не рабочие часы или качество работы. Сравнивайте и объём расписания: день с несколькими небольшими делами отличается от дня с одной большой задачей.",
          ],
          [
            "Просматривайте таблицу и историю дней",
            "Таблица планов показывает 30 запланированных дней выбранной группы будней или выходных. История дней содержит записи по датам вокруг выбранного дня. Будущие даты доступны для просмотра, но отметить выполнение заранее нельзя. Эти представления помогают заметить повторяющуюся трудность и изменить время или объём плана.",
          ],
        ],
        steps: [
          "В сегодняшнем списке отмечайте только завершённые дела.",
          "Откройте неделю и сравните выполненные планы с нагрузкой по дням.",
          "Просмотрите таблицу или историю дней; измените распорядок, если задаче регулярно нужно другое время или меньший объём.",
        ],
        example: [
          "3 дела в плане · 2 выполнено",
          "Выполнение: 2 ÷ 3 ≈ 67%",
          "Следующий шаг: найти время для оставшегося дела",
        ],
        faq: [
          [
            "Можно ли использовать DayX как трекер привычек?",
            "Добавьте в повторяющиеся планы чтение или изучение языка и отслеживайте выполнение по дням. Отметки для каждого плана сохраняются по датам отдельно.",
          ],
          [
            "Увижу ли я прогресс на другом устройстве?",
            "Да. Войдите в тот же аккаунт, чтобы открыть сохранённые на сервере планы и историю выполнения. При регистрации планы из гостевого режима переходят в новый аккаунт.",
          ],
        ],
      },
    },
  },
  {
    id: "daily-system",
    labels: {
      uz: "Kundalik tizim",
      en: "Daily system",
      ru: "Ежедневная система",
    },
    term: "Daily system",
    icon: "pomodoro",
    route: "pomodoro",
    copy: {
      uz: {
        title: "Kundalik reja va diqqat tizimi — Daily system | DayX",
        heading: "Reja, diqqat va natijani bitta odatga aylantiring.",
        description:
          "DayX daily system: kunlik rejalar, Pomodoro taymeri va natijalar kuzatuvi bir joyda. O‘qish yoki ish uchun kundalik tizim yaratishni o‘rganing.",
        summary:
          "Kunlik reja, Pomodoro va haftalik tahlilni bitta ish tartibiga birlashtiring.",
        intro:
          "Daily system — har kuni qayta foydalanadigan sodda ish tartibi. DayX’da reja tuzish, bitta ishga diqqat berish va bajarilganini ko‘rish bir-birini to‘ldiradi. Tizim o‘qish uchun ham, kundalik ish uchun ham sizning vaqtingizga mos bo‘lishi mumkin.",
        sections: [
          [
            "Ertalab: rejangizni tanlang",
            "Bugungi ro‘yxatni oching va eng muhim ishni aniqlang. Ish kunlari hamda dam olish kunlari uchun turli rejalar tuzishingiz mumkin. Yaqin imtihon yoki muhim sanani imtihonlar bo‘limida qayd eting; tayyorgarlik ishlarini esa kunlik rejangizga qo‘shing.",
          ],
          [
            "Ish paytida: bitta diqqat sessiyasi",
            "Pomodoro — ish oralig‘i va tanaffusni navbatlashtirish usuli. Masalan, 25 daqiqa ishlash va 5 daqiqa dam olish bilan boshlashingiz mumkin. DayX Pomodoro bo‘limida ish, dam olish va takrorlanishlarni o‘zingizga moslang. Taymerni boshlash vazifani avtomatik bajarilgan qilmaydi; ishni tugatgach, rejangizda belgilang.",
          ],
          [
            "Hafta oxirida: tizimni moslang",
            "Haftalik natijaga qarab qaysi reja muntazam bajarilganini va qaysisiga ko‘proq vaqt kerakligini ko‘ring. Tizimning maqsadi kunni to‘ldirish emas, keyingi ishni tushunarli qilish. Rejani kamaytirish, ish vaqtini almashtirish yoki tanaffusni uzaytirish ham foydali o‘zgartirish bo‘lishi mumkin.",
          ],
        ],
        steps: [
          "Rejalarni boshqarishda bugungi maqsadingizga mos takrorlanuvchi rejani yarating.",
          "Pomodoro’da bitta ish oralig‘i va tanaffusni sozlab, diqqat sessiyasini boshlang.",
          "Tugatgan ishni bugungi ro‘yxatda belgilang; hafta oxirida natijaga qarab rejangizni moslang.",
        ],
        example: [
          "Reja · Dars mavzusini takrorlash",
          "Diqqat · 25 daqiqa ish + 5 daqiqa tanaffus",
          "Natija · Tugagan ishni ro‘yxatda belgilash",
        ],
        faq: [
          [
            "DayX faqat talabalar uchunmi?",
            "Yo‘q. O‘qish, ish yoki shaxsiy maqsadlar uchun o‘z rejalaringizni tuzishingiz mumkin. Imtihon sanalari talabalar uchun qo‘shimcha vosita, qolgan reja va diqqat vositalari esa har xil ish tartiblariga mos keladi.",
          ],
          [
            "DayX’dan foydalanish narxi qancha?",
            "Saytda oyiga $1 tarifi ko‘rsatilgan. Hozir to‘lov qabul qilish yoqilmagan; ish maydonidan foydalanishda davom etishingiz mumkin. Bu narx ko‘rsatilishi avtomatik pul yechilishini anglatmaydi.",
          ],
        ],
      },
      en: {
        title: "Daily system for planning, focus and progress | DayX",
        heading: "Turn plans, focus and progress into a daily rhythm.",
        description:
          "Build a daily system with DayX: daily plans, a Pomodoro timer and progress tracking in one workspace. A practical routine for studying and everyday work.",
        summary:
          "Bring daily plans, Pomodoro sessions and weekly reflection into one routine.",
        intro:
          "A daily system is a simple routine you can return to. DayX connects planning, focused work and a record of completed plans so that the next step stays clear, whether you are studying or working toward a personal goal.",
        sections: [
          [
            "Morning: choose the work that matters",
            "Open Today and identify the most important task. You can keep different shared routines for weekdays and weekends. Record an upcoming exam or important date in Exam Dates, then add the preparation work to your daily plans. This separates the deadline from the work needed to reach it.",
          ],
          [
            "During work: protect one focus session",
            "Pomodoro alternates a work interval with a break. A possible starting point is 25 minutes of work followed by a 5-minute break. In DayX, you can adjust work, rest and repetitions in Pomodoro. Starting a timer does not automatically complete a plan: mark the task in your daily list after you finish the work.",
          ],
          [
            "At the end of the week: adapt the system",
            "Review Weekly to see which plans you completed regularly and which need more space. A useful daily system makes the next action understandable; it does not require filling every hour. Reduce a task, change its schedule or lengthen a break when the current routine does not fit your real day.",
          ],
        ],
        steps: [
          "Create a repeating plan in Manage Plans that supports your current goal.",
          "Set a work interval and break in Pomodoro, then start one focused session.",
          "Mark the finished work in Today. At the end of the week, use your results to adjust the routine.",
        ],
        example: [
          "Plan · Review a lesson topic",
          "Focus · 25 minutes of work + 5-minute break",
          "Progress · Mark the finished work in your list",
        ],
        faq: [
          [
            "Is DayX only for students?",
            "No. You can create your own plans for study, work or personal goals. Exam Dates is an extra tool for deadlines, while the planning and focus tools support different routines.",
          ],
          [
            "How much does DayX cost?",
            "The website displays a $1-per-month plan. Payments are not enabled yet, and you can continue using the workspace. The displayed price does not mean you will be charged automatically.",
          ],
        ],
      },
      ru: {
        title: "Ежедневная система планирования и фокуса | DayX",
        heading: "Объедините планы, фокус и прогресс в ежедневный ритм.",
        description:
          "Создайте ежедневную систему в DayX: планы на день, таймер Помодоро и отслеживание прогресса в одном пространстве. Для учёбы, работы и личных целей.",
        summary:
          "Объедините планы, сессии Помодоро и недельный обзор в один распорядок.",
        intro:
          "Daily system — простой ежедневный распорядок, к которому можно возвращаться. DayX связывает планирование, сосредоточенную работу и отметки выполнения, чтобы следующий шаг был понятным в учёбе, работе и личных целях.",
        sections: [
          [
            "Утром: выберите главное дело",
            "Откройте сегодняшний день и определите важнейшую задачу. Можно использовать разные общие планы для будней и выходных. Запишите предстоящий экзамен или важную дату в разделе экзаменов, а подготовку добавьте в ежедневные планы. Так срок отделяется от работы, необходимой для его достижения.",
          ],
          [
            "Во время работы: одна сессия фокуса",
            "Метод Помодоро чередует рабочий интервал и перерыв. Например, можно начать с 25 минут работы и 5 минут отдыха. В DayX можно настроить работу, отдых и повторы в разделе Помодоро. Запуск таймера не отмечает план выполненным автоматически: после завершения дела поставьте отметку в ежедневном списке.",
          ],
          [
            "В конце недели: настройте систему",
            "В недельном обзоре посмотрите, какие планы выполнялись регулярно, а каким нужно больше времени. Полезная система делает следующее действие понятным, а не заполняет каждый час. Уменьшите объём задачи, измените расписание или увеличьте перерыв, если распорядок не соответствует вашему дню.",
          ],
        ],
        steps: [
          "Создайте в управлении планами повторяющийся план для текущей цели.",
          "Настройте рабочий интервал и перерыв в Помодоро, затем начните одну сессию фокуса.",
          "Отметьте завершённое дело в сегодняшнем списке. В конце недели скорректируйте распорядок по результатам.",
        ],
        example: [
          "План · Повторить тему урока",
          "Фокус · 25 минут работы + 5 минут отдыха",
          "Прогресс · Отметить завершённое дело",
        ],
        faq: [
          [
            "DayX предназначен только для студентов?",
            "Нет. Вы можете создавать свои планы для учёбы, работы и личных целей. Даты экзаменов — дополнительный инструмент для сроков, а планирование и фокус подходят разным распорядкам.",
          ],
          [
            "Сколько стоит DayX?",
            "На сайте указан тариф $1 в месяц. Приём платежей пока не включён, и пространством можно продолжать пользоваться. Отображаемая цена не означает автоматического списания денег.",
          ],
        ],
      },
    },
  },
];

export function publicPage(path) {
  const [, language, id, extra] = path.split("/");
  if (extra !== undefined || !PUBLIC_LANGUAGES.includes(language)) return null;
  const topic = PUBLIC_TOPICS.find((topic) => topic.id === id);
  return topic ? { language, topic, copy: topic.copy[language] } : null;
}
export function publicPaths() {
  return PUBLIC_LANGUAGES.flatMap((language) =>
    PUBLIC_TOPICS.map((topic) => `/${language}/${topic.id}`),
  );
}
